(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-hero-carousel"] && !Shopify.designMode) return;
  try {
    class ProductHeroCarousel extends HTMLElement {
    connectedCallback() {
      // Swiper will handle navigation automatically with the navigation attributes
    }
  }

  customElements.define('product-hero-carousel', ProductHeroCarousel);
  } catch(e) { console.error(e); }
})();

})();
